import { Modal } from "antd";
import AuthenticatorContent from "./authentidicatoreContent";

const AuthenticatorModal = ({ visible, onClose, onSuccess, username }) => {
    return (
        <Modal
            title="Vérification Google Authenticator"
            open={visible}
            onCancel={onClose}
            footer={null}
            centered
            width={600}
        >
            <AuthenticatorContent username={username} onSuccess={onSuccess} onCancel={onClose}/>
        </Modal>
    );
};

export default AuthenticatorModal;
